// Alert filtering utilities based on Notion document requirements

import { AlertType } from '../api/staff';

// Alert types that should be excluded from the alerts section
// Based on Notion document: "Care notes, Recommendations and Supplements uploaded alerts should not come to the alert section"
export const EXCLUDED_ALERT_TYPES = [
  'care_notes_uploaded',
  'recommendations_uploaded', 
  'supplements_uploaded'
];

// Alert types that should be included in the alerts section
export const INCLUDED_ALERT_TYPES = [
  AlertType.NOTE_MENTION,
  AlertType.BIO_AGE_CALCULATED,
  AlertType.BIOMARKER_PENDING,
  AlertType.BIOMARKER_AWAITING,
  AlertType.BIOMARKER_URGENT,
  AlertType.REPORT_REVIEW_OVERDUE,
  AlertType.REPORT_DISCUSSION_OVERDUE,
  AlertType.MEDICAL_CARD_INCOMPLETE,
  AlertType.TULI_APPOINTMENT_COMPLETE_OVERDUE,
  AlertType.NUTRITIONIST_INVITE_OVERDUE,
  AlertType.FUTURE_TEST,
  'follow_on_created'
];

// Filter alerts based on inclusion/exclusion rules
export const filterAlertsForDisplay = (alerts: any[]): any[] => {
  return alerts.filter(alert => {
    // Include only the specified alert types
    return INCLUDED_ALERT_TYPES.includes(alert.type as AlertType);
  });
};

// Check if an alert type should be displayed
export const shouldDisplayAlert = (alertType: string): boolean => {
  return INCLUDED_ALERT_TYPES.includes(alertType as AlertType);
};

// Get alert priority for sorting (higher number = higher priority)
export const getAlertPriority = (alertType: string): number => {
  const priorityMap: Record<string, number> = {
    [AlertType.BIOMARKER_URGENT]: 10,
    [AlertType.FUTURE_TEST]: 9.5,
    [AlertType.MEDICAL_CARD_INCOMPLETE]: 9,
    [AlertType.REPORT_REVIEW_OVERDUE]: 8,
    [AlertType.REPORT_DISCUSSION_OVERDUE]: 7,
    [AlertType.TULI_APPOINTMENT_COMPLETE_OVERDUE]: 6,
    [AlertType.NUTRITIONIST_INVITE_OVERDUE]: 5,
    [AlertType.BIOMARKER_PENDING]: 4,
    [AlertType.BIOMARKER_AWAITING]: 3,
    [AlertType.BIO_AGE_CALCULATED]: 2,
    [AlertType.NOTE_MENTION]: 1,
    'follow_on_created': 1.5
  };
  
  return priorityMap[alertType] || 0;
};

// Sort alerts by priority (highest first) then by creation date (newest first)
export const sortAlertsByPriority = (alerts: any[]): any[] => {
  return [...alerts].sort((a, b) => {
    const priorityA = getAlertPriority(a.type);
    const priorityB = getAlertPriority(b.type);
    
    if (priorityA !== priorityB) {
      return priorityB - priorityA; // Higher priority first
    }
    
    // If same priority, sort by creation date (newest first)
    const dateA = new Date(a.created_at || 0).getTime();
    const dateB = new Date(b.created_at || 0).getTime();
    return dateB - dateA;
  });
};
